import { queryOptions } from '@tanstack/react-query'
import {
  fetchCMSCatNavData,
  fetchCMSContentAlias,
  fetchCMSData,
  fetchCMSGlobalHeaderCategories,
} from '@/features/cms/services/CMS/fetchers'
import { type getAddressParamsForCMS } from '@/features/cms/services/CMS/utils'
import { type ContentAliasMap } from '@/features/cms/components/CMS/types'
import { type StoreParams } from '@/features/shared/utils/dataFetching/storeParams'
import { type ParsedUrlQuery } from 'node:querystring'

export type CMSInputVariables = {
  retailer_name?: string
}

export type CmsQueryOptionsParams = {
  storeParams: StoreParams
  addressParams: ReturnType<typeof getAddressParamsForCMS>
  subscriptionType: string | undefined
  hasPlacedMarketplaceOrder: boolean | undefined
  inputVariables?: CMSInputVariables
  utmParams?: ParsedUrlQuery
}

export const getCMSQueryKeySlug = (slug: string): Readonly<`CMS_${string}`> => `CMS_${slug}`

export const cmsQueryOptions = (
  params: CmsQueryOptionsParams & {
    slug: string
    enableDeferredHydration: boolean
  },
) => {
  return queryOptions({
    queryKey: [getCMSQueryKeySlug(params.slug), params],
    queryFn: fetchCMSData,
  })
}

export const cmsGlobalHeaderCategoriesOptions = (params: CmsQueryOptionsParams) =>
  queryOptions({
    queryKey: ['CMS_GLOBAL_HEADER_CATEGORIES_OPTIONS', params] as const,
    queryFn: fetchCMSGlobalHeaderCategories,
  })

export const catNavCmsQueryOptions = (params: CmsQueryOptionsParams) =>
  queryOptions({
    queryKey: ['CMS_CAT_NAV', params],
    queryFn: fetchCMSCatNavData,
  })

export const cmsContentAliasQueryOptions = <T extends keyof ContentAliasMap>(
  contentAlias: T,
  params: CmsQueryOptionsParams,
) =>
  queryOptions({
    queryKey: [`CMS_${contentAlias}`, params] as const,
    queryFn: fetchCMSContentAlias<ContentAliasMap[T]>,
  })
